import React from "react"
import { Box, Container, Flex } from "@theme-ui/components"
import VideoStream from "./VideoStream"

const HomeVideoCard = ({ block, media }) => {
  return (
    <Box>
      <Container
        variant="fw"
        sx={{
          position: "relative",
          mt: [4, 4, 4, 7],
          overflow: "hidden",
          padding: [0, 0, 3, 4],
        }}
      >
        <Box
          sx={{
            borderRadius: ["30px", "30px", "60px"],
            overflow: "hidden",
            height: ["30vh", "30vh", "1080px"],
            width: "100%",
            aspectRatio: "1/1",
          }}
        >
          {media.mimeType === "video/mp4" && (
            <VideoStream
              muxPlaybackId={media.video.muxPlaybackId}
              customData={media.customData}
              aspectRatio={"1/1"}
              minHeight={"100%"}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                bottom: "50%",
                width: "100%",
                height: "100%",
                zIndex: 1,
                transform: "translate(-50%, -50%)", // This line centers the video
              }}
            />
          )}

          <Flex
            columns={[2]}
            sx={{
              display: ["none", "none", "flex", "flex"],
              fontSize: [3],
              position: "absolute",
              top: "40%",
              left: "10%",
              zIndex: 2,
              width: "25%",
              color: "white",
              h4: {
                mt: 4,
                mb: 0,
              },
              p: {
                my: 0,
              },
            }}
          >
            <Box
              sx={{ display: ["none", "none", "block", "block"] }}
              dangerouslySetInnerHTML={{ __html: block.body }}
            />
          </Flex>
        </Box>
      </Container>
      <Flex
        columns={[2]}
        sx={{
          display: ["flex", "flex", "none", "none"],
          padding: [3, 4],
          zIndex: 2,
          width: "100%",
          color: "#131E26",
          h4: {
            mt: 4,
            mb: 0,
          },
          p: {
            my: 0,
          },
        }}
      >
        <Box
          sx={{ display: ["block", "block", "none", "none"] }}
          dangerouslySetInnerHTML={{ __html: block.body }}
        />
      </Flex>
    </Box>
  )
}

export default HomeVideoCard
